export const LogscordVisionConvictions = [
    {
        icon: "volunteer_activism",
        titleKey: "vision.convictions.responsibility.title",
        descriptionKey: "vision.convictions.responsibility.description",
    },
    {
        icon: "shield_lock",
        titleKey: "vision.convictions.limits.title",
        descriptionKey: "vision.convictions.limits.description",
    },
    {
        icon: "policy",
        titleKey: "vision.convictions.access.title",
        descriptionKey: "vision.convictions.access.description",
    },
    {
        icon: "auto_delete",
        titleKey: "vision.convictions.retention.title",
        descriptionKey: "vision.convictions.retention.description",
    },
    {
        icon: "diversity_3",
        titleKey: "vision.convictions.communities.title",
        descriptionKey: "vision.convictions.communities.description",
    },
];
export const LogscordVisionFaqGroups = [
    {
        key: "responsibility",
        kickerKey: "vision.faq.groups.responsibility.kicker",
        titleKey: "vision.faq.groups.responsibility.title",
        questionIds: [
            "powerful-platform",
            "surveillance",
            "philosophy",
            "responsibility",
            "objective",
        ],
    },
    {
        key: "data",
        kickerKey: "vision.faq.groups.data.kicker",
        titleKey: "vision.faq.groups.data.title",
        questionIds: [
            "privacy",
            "access-policies",
            "deleted-messages",
            "all-messages",
            "retention",
            "gdpr",
        ],
    },
    {
        key: "communities",
        kickerKey: "vision.faq.groups.communities.kicker",
        titleKey: "vision.faq.groups.communities.title",
        questionIds: [
            "free-small-servers",
            "free-costly-platform",
            "non-customers",
            "classic-log-bots",
        ],
    },
    {
        key: "independence",
        kickerKey: "vision.faq.groups.independence.kicker",
        titleKey: "vision.faq.groups.independence.title",
        questionIds: [
            "europe",
            "switzerland",
            "open-source",
            "trust",
            "ecology",
        ],
    },
];
//# sourceMappingURL=vision.js.map